/** Cleanup steps are independent: a damaged recorder must not leave private
 * notifications or widgets visible after sign-out. Report failure after trying all. */
export async function runNativeAccountTransition(
  steps: Array<() => Promise<void>>,
) {
  const errors: unknown[] = [];
  for (const step of steps) {
    try {
      await step();
    } catch (error) {
      errors.push(error);
    }
  }
  if (errors.length)
    throw new AggregateError(errors, "Native account cleanup needs retry");
}
